import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 21h-8a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10c.265 0 .518 .052 .75 .145","key":"svg-0"}],["path",{"d":"M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0","key":"svg-1"}],["path",{"d":"M8 11v-4a4 4 0 1 1 8 0v4","key":"svg-2"}],["path",{"d":"M19 22v.01","key":"svg-3"}],["path",{"d":"M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483","key":"svg-4"}]]

const IconLockQuestion = createReactComponent('outline', 'lock-question', 'LockQuestion', __iconNode);

export default IconLockQuestion;